import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Header from '../shared/Header';
import { Card, Container, Row, Col, Badge, ListGroup } from "react-bootstrap";
import axios from 'axios';
import getAPI from '../../service/getAPI';
import TableLoader from '../widgets/TableLoader';

const TrackCourier = () => {
    const { trackingId } = useParams();
    const [trackingData, setTrackingData] = useState({});
    const [isLoading, setIsLoading] = useState({});
    const { master } = getAPI();

    useEffect(() => {
        fetchDataByTrackingId(trackingId);
        // eslint-disable-next-line
    }, []);

    const fetchDataByTrackingId = async (trackingId) => {
        setIsLoading(true);
        try {
            let body = {
                tracking_number: trackingId
            }
            let res = await axios.post(master.getTrackingDataById, body);
            if (res.data?.data.length > 0) {
                if (res.data.data[0]["tracking_array"]) {
                    res.data.data[0]["tracking_array"] = JSON.parse(res.data?.data[0]["tracking_array"]);
                    res.data?.data[0]?.tracking_array.sort((a, b) => new Date(b.date) - new Date(a.date));
                }
                setTrackingData(res.data?.data[0]);
            } else {
                setTrackingData({})
            }
        } catch (err) {
            console.error(err);
            window.alert("Something went wrong!");
            setTrackingData({});
        }
        setIsLoading(false);
    }

    const formatDate = (isoDate) => {
        return new Date(isoDate).toLocaleDateString("en-IN");
    };

    const statusVariant = (status) => {
        switch (status) {
            case "DELIVERED":
                return "success";
            case "PROCESSING":
                return "warning";
            case "UNDELIVERED":
                return "danger";
            default:
                return "secondary";
        }
    };

    return (
        <>
            <Header isPublic={true} />
            <br />
            <br />

            <Container className="my-4">
                <h2 className="mb-4 text-center">Tracking Details</h2>
                {isLoading ? (<div className='text-center mt-4'>
                    <br />
                    <TableLoader />
                </div>) : (Object.keys(trackingData).length > 0 ? <>

                    <Card>
                        <Card.Body>
                            <Row className='my-2'>
                                <Col md={6} className='my-2'>
                                    <Card>
                                        <Card.Body>
                                            <Row>
                                                <Col md={4} className='my-1'>
                                                    <strong>Order Date:</strong>
                                                </Col>
                                                <Col md={8} className='my-1'>
                                                    <span> {formatDate(trackingData.order_date)}</span>
                                                </Col>
                                                <Col md={4} className='my-1'>
                                                    <strong>Tracking Number:</strong>
                                                </Col>
                                                <Col md={8} className='my-1'>
                                                    <span> {trackingData.tracking_number}</span>
                                                </Col>
                                                <Col md={4} className='my-1'>
                                                    <strong>Courier:</strong>
                                                </Col>
                                                <Col md={8} className='my-1'>
                                                    <span> {trackingData.shipping_courier}</span>
                                                </Col>
                                                <Col md={4} className='my-1'>
                                                    <strong>Customer:</strong>
                                                </Col>
                                                <Col md={8} className='my-1'>
                                                    <span> {trackingData.customer_name}</span>
                                                </Col>
                                                <Col md={4} className='my-1'>
                                                    <strong>Phone:</strong>
                                                </Col>
                                                <Col md={8} className='my-1'>
                                                    <span> {trackingData.phone_number}</span>
                                                </Col>
                                                <Col md={4} className='my-1'>
                                                    <strong>Product:</strong>
                                                </Col>
                                                <Col md={8} className='my-1'>
                                                    <span> {trackingData.product}</span>
                                                </Col>
                                                <Col md={4} className='my-1'>
                                                    <strong>Address:</strong>
                                                </Col>
                                                <Col md={8} className='my-1'>
                                                    <span> {trackingData.address}, {trackingData.state} - {trackingData.pincode}</span>
                                                </Col>
                                                <Col md={4} className='my-1'>
                                                    <strong>Courier Status:</strong>
                                                </Col>
                                                <Col md={8} className='my-1'>
                                                    <span>
                                                        <Badge bg={statusVariant(trackingData.courier_status)}>{trackingData.courier_status !== "" ? trackingData.courier_status : "N/A"}</Badge>
                                                    </span>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col className='my-2' style={{ maxHeight: '450px', overflowY: 'auto' }}>
                                    <Card>
                                        <Card.Body>
                                            <ListGroup>
                                                {trackingData?.tracking_array &&
                                                    trackingData?.tracking_array?.map((row, index) => <div key={index} className='row'>
                                                        <ListGroup.Item className='border-0'>
                                                            <span className='badge text-bg-light'>{new Date(row?.date).toLocaleDateString("en-IN")} {new Date(row?.date).toLocaleTimeString()}</span> <br />
                                                            <span className='ms-2'><strong>Activity:</strong> {row?.activity}</span> <br />
                                                            <span className='ms-2'><strong>Location:</strong> {row?.location}</span> <br />
                                                        </ListGroup.Item>
                                                    </div>)
                                                }
                                            </ListGroup>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </> :
                    (<Card>
                        <Card.Body>
                            <div className="text-center mt-4">
                                <p>No Data Available</p>
                            </div>
                        </Card.Body>
                    </Card>)
                )}
            </Container>
        </>
    )
}

export default TrackCourier
